import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Calendar, Settings, Users } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function OneOnOneSetupPageStub() {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-5xl mx-auto space-y-6">
        <header className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 text-primary font-semibold">1</span>
            <h1 className="text-3xl font-bold text-foreground">Recurring 1-on-1 setup</h1>
          </div>
          <p className="text-muted-foreground">
            The Vite port still needs the full scheduling workflow from the Next.js app. Until it is migrated, use the dashboard
            list to create sessions manually or continue working in the legacy frontend.
          </p>
        </header>

        <div className="grid gap-4 md:grid-cols-3">
          <Card className="border-dashed">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Calendar className="h-5 w-5 text-primary" />
                Recurrence
              </CardTitle>
              <CardDescription>Configuration UI to repeat sessions is pending implementation.</CardDescription>
            </CardHeader>
          </Card>
          <Card className="border-dashed">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Users className="h-5 w-5 text-primary" />
                Participants
              </CardTitle>
              <CardDescription>Use the existing modals to manage participants until the full wizard is migrated.</CardDescription>
            </CardHeader>
          </Card>
          <Card className="border-dashed">
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-lg">
                <Settings className="h-5 w-5 text-primary" />
                Agenda
              </CardTitle>
              <CardDescription>Default agendas and question banks will be brought over in a follow-up patch.</CardDescription>
            </CardHeader>
          </Card>
        </div>

        <Card>
          <CardContent className="p-6 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
            <div>
              <Badge variant="outline" className="mb-2">Migration in progress</Badge>
              <p className="text-sm text-muted-foreground max-w-xl">
                Need the advanced tooling right away? Continue using the Next.js route <code className="mx-1">/one-on-one-setup</code>
                while the Vite experience is completed.
              </p>
            </div>
            <Button asChild variant="outline">
              <Link to="/dashboard/one-on-ones">Open 1-on-1 list</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
